//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Box, Text } from "@chakra-ui/react";
import { SubjectPickerDrawerOrModal } from "../SubjectPicker";
import {
  useOverlayDisclosure,
  OverlayRoute,
  OverlayWrapper,
} from "../../../../components/OverlayRouter";

export const defaultValue = { class: "", purpose: "", subjects: [] };
let defaultPlaceholders = {
  class: {
    placeholder: "Select Class",
    label: "What class is this child?",
  },
  purpose: {
    placeholder: "Select",
    label: "Select Child's Purpose",
  },
  subjects: {
    label: "Subjects do you need help with?",
    placeholder: "Select Subjects",
  },
};

const formatValue = (value, delimiter) => {
  return value.split(" ").join(delimiter);
  // .toLowerCase();
};

const formatOptions = (options, delimiter = "") =>
  options.map((item) => ({ label: item, value: formatValue(item, delimiter) }));

const SubjectSelectorCTX = React.createContext({});
export const useSubjectSelectorContext = () => {
  let manager = React.useContext(SubjectSelectorCTX);
  return manager;
};
export const SubjectSelectorProvider = ({
  children,
  dataType,
  placeholders,
  path,
  paths = "/subject-edit",
}) => {
  let [data, setData] = useState({ subjects: [] });
  let [subjects, setSubjects] = useState([]);
  let [options, setOptions] = useState([]);
  let [_placeholder, setPlaceHolder] = useState();
  let [subjectUpdated, setSubjectUpdated] = useState(false);
  const [edit, setEdit] = useState(false);

  let { isOpen, onClose, onOpen } = useOverlayDisclosure(path);
  // React.useEffect(() => {
  //   setData(initialData);
  // }, [initialData]);
  const onChange = React.useCallback(
    (x) => {
      setData(() => x);
    },
    [setData, data]
  );
  const xOnOpen = React.useCallback(
    ({ valueProp, options, placeholder }) => {
      // setData(valueProp);
      setOptions(options);
      setPlaceHolder(placeholder);
      onOpen();
    },
    [setData, onOpen]
  );
  const ctx = React.useMemo(() => {
    // console.log("subjects", data.subjects);
    return {
      onChange,
      data,
      subjects,
      edit,
      onOpen: xOnOpen,
      toggleEdit: setEdit,
      updatePlaceholder: setPlaceHolder,
      subjectUpdated,
    };
  }, [
    data,
    onChange,
    edit,
    setEdit,
    setPlaceHolder,
    xOnOpen,
    subjects,
    subjectUpdated,
  ]);
  return (
    <SubjectSelectorCTX.Provider value={ctx}>
      {children}
      <OverlayWrapper
        exact={false}
        path={paths}
        // path={path}
      >
        <>
          {isOpen ? (
            <SubjectPickerDrawerOrModal
              options={options}
              isOpen={isOpen}
              onClose={onClose}
              onChange={(x) => {
                setSubjectUpdated(true);
                setSubjects(x);
                setData({ ...data, subjects: x });
                // onChange();
              }}
              valueProp={data.subjects}
              dataType={dataType}
              placeholder={_placeholder}
            />
          ) : null}
        </>
      </OverlayWrapper>
    </SubjectSelectorCTX.Provider>
  );
};
let formatSubject = (subjects) =>
  subjects.map((subject) => ({
    label: subject.name,
    value: subject.shortName.split(" ").join("_"),
  }));
const getSubjectOptions = (purposeOptions, selectedPurpose) => {
  let foundPurpose = purposeOptions.find(
    (purpose) => purpose.label === selectedPurpose.label
  );
  if (foundPurpose) {
    let { subjects } = foundPurpose;
    let preSelected = subjects.filter((subject) => subject.isPreselected);
    return {
      subjects: formatSubject(subjects),
      pre_selected: formatSubject(preSelected),
    };
  }
  return {};
};
const getPurposeOptions = (selectedClass, dataType) => {
  let classOptions = formatOptions(dataType ? Object.keys(dataType) : []);
  let vxl = classOptions.find((classObj) => classObj.value === selectedClass);
  let transformedPurposes = [];
  if (vxl) {
    let label = vxl.label;
    let { purposes } = dataType[label];
    transformedPurposes = purposes.map(({ name, description, ...rest }) => ({
      label: (
        <Box py={1}>
          <Text lineHeight="short" fontWeight="medium">
            {name}
          </Text>
          {description && <Text fontSize="sm">{description}</Text>}
        </Box>
      ),
      value: formatValue(name, "_"),
      ...rest,
    }));
  }
  return transformedPurposes;
};
export function getPurposesAndOptions(values, dataType) {
  if (values.class && values.purpose) {
    let purposeOptions = getPurposeOptions(values.class, dataType);
    let foundPurpose = purposeOptions.find(
      (option) => option.value === values.purpose
    );
    if (!foundPurpose) {
      // choose the first one
      foundPurpose = purposeOptions[0];
    }
    let { subjects } = getSubjectOptions(purposeOptions, foundPurpose);
    return {
      purpose: purposeOptions,
      subjects,
    };
  }
  return undefined;
}
function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length != b.length) return false;

  // If you don't care about the order of the elements inside
  // the array, you should sort both arrays here.
  // Please note that calling sort on an array will modify that array.
  // you might want to clone your array first.

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}
export const useSubjectSelector = (
  value = defaultValue,
  placeholders = defaultPlaceholders,
  dataType
) => {
  let academicData = dataType;
  // let academicData = ACADEMICS_DATA;
  const [values, setValues] = useState(value);
  const [options, setOptions] = useState({ purpose: [], subjects: [] });

  let classOptions = formatOptions(
    academicData ? Object.keys(academicData) : []
  );

  const saveValues = (data) => {
    setValues(data);
  };
  const handleChange = (key, selectedOption) => {
    if (key === "class") {
      let purposeOptions = getPurposeOptions(
        selectedOption.value,
        academicData
      );

      // If there's only 1 purpose, select it
      if (purposeOptions.length === 1) {
        let firstPurpose = purposeOptions[0];
        let { subjects, pre_selected } = getSubjectOptions(
          purposeOptions,
          firstPurpose
        );
        let newValues = {
          ...values,
          class: selectedOption.value,
          purpose: firstPurpose.value,
          subjects: pre_selected.map((item) => item.value),
        };

        setOptions({ ...options, purpose: purposeOptions, subjects });
        saveValues(newValues);
      } else {
        let newValues = {
          ...values,
          class: selectedOption.value,
          subjects: [],
          purpose: "",
        };

        setOptions({ ...options, purpose: purposeOptions });
        saveValues(newValues);
      }
    } else if (key === "purpose") {
      let { subjects, pre_selected } = getSubjectOptions(
        options.purpose,
        selectedOption
      );
      let newValues = {
        ...values,
        purpose: selectedOption.value,
        subjects: pre_selected.map((item) => item.value),
      };

      setOptions({ ...options, subjects });
      saveValues(newValues);
    } else {
      // let subjectValues = selectedOption.map(item => item.value);
      let newValues = { ...values, subjects: selectedOption };
      saveValues(newValues);
    }
  };

  useEffect(() => {
    let result = getPurposesAndOptions(values, academicData);
    if (result) {
      setOptions({
        ...options,
        ...result,
      });
    }
    // if (values.class && values.purpose) {
    //   let purposeOptions = getPurposeOptions(values.class, academicData);
    //   let foundPurpose = purposeOptions.find(
    //     option => option.value === values.purpose
    //   );
    //   let { subjects } = getSubjectOptions(purposeOptions, foundPurpose);
    // }
  }, []);

  return { values, handleChange, options, classOptions, placeholders };
};
